<template>
  <div id="container">
    <!-- header -->
    <div id="lp-wrap">
      <!-- main -->
      <div class="content">
        <div><img class="ogp" :src="logo"></div>
        <p class="ogp">3分でオンライン会議があったまる新感覚アイスブレークツール（β版）。</p>
        <div id="koe">
          <section id="koemain">
            <h1><img :src="logo" alt="声のつなひき"></h1>

            <!-- step1 -->
            <div class="step1" v-if="step1Flag">
              <div class="message">
                <p>さあ&emsp;オンラインで&emsp;なかまと&emsp;綱引きしよう！<br> ここでは「ちから」ではなく<br> 「声」の大きさで勝敗が決まる！！</p>
                <p><a class="btn" @click="create_room()">つなひき会場を作成する</a></p>
              </div>
              <p class="memo">※スマホには対応していません（ゴメンナサイ）</p>
            </div>

            <!-- step2 -->
            <div class="step2" v-else-if="step2Flag">
              <div class="message">
                <p><strong>つなひき会場を下記URLに作成しました</strong></p>
                <p>１、URLを開いて「入場」をすませよう。仲間にもシェア。</p>
                <p><input type="text" v-model="entryUrl" id="player_entry_url" readonly="readonly" ref="copy_target_text"><a class="mini" id="player_entry_url_copy_button" @click="copy_text()"><i class="fa fa-copy"></i> URLをコピー</a></p>
                <p>２、全員が「入場」したのを確認したら、開始ボタンをクリック！</p>
                <a class="btn" @click="start_game()">つなひき開始!!</a>
              </div>
            </div>

            <!-- step3 -->
            <div class="step3" v-else-if="step3Flag">
              <div class="message">
                <p><strong>あなたの作った会場URLで、試合が開始されました</strong></p>
                <p>このページは用済みになりました。<br /> またやりたい時はこのボタンをおしてね。</p>
                <a class="btn" @click="create_room()">別の会場を作成する</a>
              </div>
            </div>

          </section>
        </div>
        <footer class="hwrapper">
          <div class="footer">
            <nav id="gnavi">
              <ul>
                <li><a href="https://www.phonogram.co.jp/" target="_blank" rel="noopener noreferrer">フォノグラムトップへ</a></li>
                <li><a href="https://www.phonogram.co.jp/lab/info/" target="_blank" rel="noopener noreferrer">楽しさ研究所へ</a></li>
              </ul>
            </nav>
            <small class="copyright">&copy; <a href="https://phonogram.co.jp" target="_blank" rel="noopener noreferrer">Phonogram</a>,Inc. All rights reserved.</small>
          </div>
        </footer>
      </div>
    </div>
  </div>
  <!-- /container -->
</template>

<script>
import logo from '@/assets/logo.png'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import {useCookies} from 'vue3-cookies'
import dayjs from "dayjs";

export default {
  name: 'Home',
  data(){
    return {
      logo: logo,
      roomId: '',
      baseUrl: 'https://space.phonogram.jp/#/game?roomId=',
      entryUrl: '',
      step1Flag: true,
      step2Flag: false,
      step3Flag: false
    }
  },
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  methods: {
    create_room() {
      const my_id = this.getMyId();

      if(my_id){
        const db = firebase.database();
        const val = db.ref('rooms');
        const newVal = val.push({
          game_flag: "ready",
          session_data: my_id,
        }, (error) => {
          if (error) {
            alert('作成に失敗しました。時間をおいて再度お試しください。時間をおいても解決しない場合は、他のブラウザまたは別の端末からお試しください。');
          } else {
            // 作成後はエントリー受付画面へ遷移
            this.roomId = newVal.key
            this.entryUrl = this.baseUrl + this.roomId

            this.step1Flag = false
            this.step2Flag = true
          }
        });
      }else{
        alert('作成に失敗しました。時間をおいて再度お試しください。時間をおいても解決しない場合は、他のブラウザまたは別の端末からお試しください。');
      }
    },
    // 自分が作成した綱引き会場の一覧表示の為、Cookie発行する
    getMyId(){
      let my_id = this.cookies.get('room')
      if( ! my_id){
        my_id = this.getUniqueStr();
        this.cookies.set('room', my_id, 7, '/')
      }
      return my_id;
    },
    // ユニークな文字列を返す
    getUniqueStr(myStrong){
      let strong = 1000;
      if (myStrong) strong = myStrong;
      return new Date().getTime().toString(16)  + Math.floor(strong*Math.random()).toString(16)
    },
    start_game() {
      const roomId = this.roomId;
      const db = firebase.database();

      // 現在日時＋30秒後を設定
      const end_time = dayjs().add(30, 's').format();

      db.ref('rooms').child(roomId).update({
        game_flag: 'start',
        end_time: end_time
      }, (error) => {
        if (error) {
          alert('ゲーム開始に失敗しました。時間をおいて再度お試しください。時間をおいても解決しない場合は、他のブラウザまたは別の端末からお試しください。');
        } else {
          this.step2Flag = false
          this.step3Flag = true
        }
      });
    },
    copy_text() {
      navigator.clipboard.writeText(this.entryUrl)
          .then(() => {
            alert('クリップボードにコピーしました');
          })
          .catch(e => {
            console.error(e)
          })
    }
  }
}
</script>

<style>
@import "../assets/css/common.css";
</style>
